 
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import api from '@services/baseApi';
import accountReducer, { tryRecoverAccount } from './accountSlice';
import adminReducer from './adminSlice';
import signatureReducer from './signatureSlice';
import themeReducer from './ThemeSlice';

const existingAccount = tryRecoverAccount();

export const reducer = {
  account: accountReducer,
  admin: adminReducer,
  signature: signatureReducer,
  theme: themeReducer,
  [api.reducerPath]: api.reducer,
};

export const store = configureStore({
  reducer,
  preloadedState: existingAccount,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Increase the warning threshold to 128ms
        warnAfter: 128,
        // Ignore RTK Query actions and paths as they handle serialization internally
        ignoredActions: [
          // Ignore all RTK Query actions
          'api/executeQuery/fulfilled',
          'api/executeQuery/pending',
          'api/executeQuery/rejected',
          'api/executeMutation/fulfilled',
          'api/executeMutation/pending',
          'api/executeMutation/rejected',
        ],
        ignoredActionPaths: ['meta.arg', 'meta.baseQueryMeta'],
        ignoredPaths: [
          // Ignore RTK Query state as it manages its own serialization
          'api.queries',
          'api.mutations',
          'api.provided',
          'api.subscriptions',
          'api.config',
        ],
      },
    }).concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
